import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled, { css } from 'styled-components';
import { theme } from 'design';
import Button from './Button';
import { IButtonProps } from './ButtonProps';

interface IButton extends IButtonProps {
  copied: boolean;
}

const StyledButton = styled(Button)<IButton>`
  ${({ copied }) =>
    copied &&
    css`
      color: ${theme.color.secondary[400]};

      &:hover {
        color: ${theme.color.secondary[400]};
      }
    `}
`;

interface IButtonCopyToClipboard {
  value?: string;
  interval?: number;
  copyLabel?: string;
  copiedLabel?: string;
  onCopy?(text: string): void;
}

let intervalId: ReturnType<typeof setTimeout>;

const ButtonCopyToClipboard: React.FC<IButtonCopyToClipboard> = ({ value, interval, copyLabel = 'Copy', copiedLabel = 'Copied!', onCopy }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => () => clearTimeout(intervalId), []);

  const handleCopy = (text: string) => {
    setCopied(true);
    onCopy?.(text);

    if (interval) {
      clearTimeout(intervalId);

      intervalId = setTimeout(() => {
        setCopied(false);
      }, interval);
    }
  };

  return (
    <CopyToClipboard text={value || ''} onCopy={handleCopy}>
      <StyledButton appearance="white" size="large" copied={copied} label={copied ? copiedLabel : copyLabel} />
    </CopyToClipboard>
  );
};

export default ButtonCopyToClipboard;
